import * as React from 'react';
import {useMemo, useState} from 'react';
import {NamedProps} from 'react-select/src/Select';

interface Props<OptionItem> {
  defaultValue?: NamedProps['defaultValue'];
  multiple?: any;
  onSelect?: (value?: string | number) => any;
  includeAll?: any;
  optionData: (OptionItem & {id: number | string; icon?: React.ReactNode})[];
  getLabel: (i: OptionItem) => string;
  getValue?: (i: OptionItem) => string;
}

export const OPTION_ALL_UNIQ_VALUE = 'this-is-all-value-from-rayyone-with-love';
export const OPTION_ALL = {label: 'All', value: OPTION_ALL_UNIQ_VALUE};

export function useDropdown<OptionItem>({
  defaultValue,
  multiple,
  onSelect,
  includeAll,
  optionData = [],
  getLabel,
  getValue,
}: Props<OptionItem>) {
  const [searchQuery, setSearchQuery] = useState<string | undefined>();
  const [value, setValue] = useState(defaultValue || (includeAll ? OPTION_ALL : undefined));

  const options = useMemo(() => {
    // let defaultOptions = defaultValue ? (isArray(defaultValue) ? [...(defaultValue || [])] : [defaultValue]) : [];
    const res: {label: string; value: string; icon?: React.ReactNode}[] = optionData?.map(item => {
      // if (defaultIds?.includes(item.id)) {
      //   defaultOptions = defaultOptions.filter(o => o.id !== item.id);
      // }
      return {label: getLabel(item), value: getValue ? getValue(item) : item.id.toString(), icon: item.icon};
    });
    // defaultOptions.forEach(o => res.unshift({label: getLabel(o), value: o.id.toString()}));
    if (includeAll) {
      res.unshift(OPTION_ALL);
    }
    return res;
  }, [optionData, includeAll, getLabel, getValue]);

  const onInputChange: NamedProps['onInputChange'] = searchValue => {
    if (searchValue === OPTION_ALL_UNIQ_VALUE) {
      setSearchQuery(undefined);
    } else {
      setSearchQuery(searchValue);
    }
  };

  const onChange: NamedProps['onChange'] = selectedOption => {
    if (!selectedOption?.value) {
      setSearchQuery(undefined);
      setValue(undefined);
      onSelect?.(selectedOption?.value);
      return;
    }

    setValue(selectedOption);
    if (selectedOption?.value === OPTION_ALL_UNIQ_VALUE) {
      onSelect?.(undefined);
      return;
    }
    onSelect?.(selectedOption?.value);

    return;
  };

  return {
    value,
    setValue,
    searchQuery,
    options,
    onInputChange,
    onChange,
  };
}
